/**
 * Login page — entry point
 */
import { authApi } from "@shared/api-client";
import { saveSession, isLoggedIn, getRole } from "@shared/auth";
import { initTheme, toggleTheme } from "@shared/theme";
import { loadLanguage, getLanguage, t, applyTranslations } from "@shared/i18n";

async function init() {
  // Aplicar tema guardado
  initTheme();

  // Cargar idioma guardado (default ES)
  await loadLanguage(getLanguage());

  // Si ya está autenticado, redirigir a la página correcta
  if (isLoggedIn()) {
    const role = getRole();
    window.location.href =
      role === "SuperAdmin" ? "/admin.html" : "/portal.html";
    return;
  }

  // ---- Botón tema ----
  document
    .getElementById("theme-toggle")
    ?.addEventListener("click", toggleTheme);

  // ---- Selectores de idioma ----
  document.getElementById("lang-es")?.addEventListener("click", async () => {
    await loadLanguage("es");
  });
  document.getElementById("lang-en")?.addEventListener("click", async () => {
    await loadLanguage("en");
  });

  // ---- Toggle ver contraseña ----
  document.getElementById("toggle-pwd")?.addEventListener("click", () => {
    const input = document.getElementById("password") as HTMLInputElement;
    const icon = document.getElementById("eye-icon")!;
    input.type = input.type === "password" ? "text" : "password";
    icon.className =
      input.type === "password"
        ? "ki-filled ki-eye text-sm"
        : "ki-filled ki-eye-slash text-sm";
  });

  // ---- Formulario de login ----
  const form = document.getElementById("login-form") as HTMLFormElement;
  const errorBox = document.getElementById("login-error")!;
  const errorMsg = document.getElementById("login-error-msg")!;
  const btnText = document.getElementById("btn-text")!;
  const btnSpinner = document.getElementById("btn-spinner")!;
  const loginBtn = document.getElementById("login-btn") as HTMLButtonElement;

  function setLoading(loading: boolean) {
    loginBtn.disabled = loading;
    btnText.textContent = loading ? t("login.loading") : t("login.submit");
    btnSpinner.classList.toggle("hidden", !loading);
  }

  function showError(msg: string) {
    errorMsg.textContent = msg;
    errorBox.classList.remove("hidden");
    // Shake animation
    errorBox.classList.add("animate-bounce");
    setTimeout(() => errorBox.classList.remove("animate-bounce"), 600);
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    errorBox.classList.add("hidden");

    const email = (
      document.getElementById("email") as HTMLInputElement
    ).value.trim();
    const password = (document.getElementById("password") as HTMLInputElement)
      .value;

    if (!email || !password) return;

    setLoading(true);
    try {
      const res = await authApi.login(email, password);
      saveSession(res.token, res.role, res.name, res.email ?? "");

      // Redirigir según rol
      if (res.role === "SuperAdmin") {
        window.location.href = "/admin.html";
      } else {
        window.location.href = "/portal.html";
      }
    } catch (err: any) {
      if (err.status === 401 || err.status === 400) {
        showError(t("login.error.invalid"));
      } else {
        showError(t("login.error.generic"));
      }
      setLoading(false);
    }
  });
}

init();
